import { render, staticRenderFns } from "./patrolCar.vue?vue&type=template&id=51882126&scoped=true&"
import script from "./patrolCar.vue?vue&type=script&lang=js&"
export * from "./patrolCar.vue?vue&type=script&lang=js&"
import style0 from "./patrolCar.vue?vue&type=style&index=0&id=51882126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51882126",
  null
  
)

export default component.exports